module.exports = __webpack_public_path__ + "static/img/american_credit_asset_based_lending.f62b355.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/american_credit_asset_based_lending.jpeg
// module id = 1646
// module chunks = 5